<template>
  <el-table :data="data">
    <el-table-column width="50" label="工序">
      <template slot-scope="scope">
        {{ scope.$index + 1 }}
      </template>
    </el-table-column>
    <el-table-column label="原材料">
      <template slot-scope="scope">
        <el-table :data="scope.row.manufacture_flow_material_relations">
          <el-table-column prop="sku" label="SKU" />
          <el-table-column prop="qty" label="数量" />
        </el-table>
      </template>
    </el-table-column>
    <el-table-column label="金额">
      <template slot-scope="scope">
        <el-table :data="scope.row.manufacture_flow_processing_plant_relations">
          <el-table-column label="加工厂">
            <template slot-scope="scope">
              <router-link :to="{ path: `/companies/${scope.row.processing_plant.id}` }">
                {{ scope.row.processing_plant.name }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column prop="processing_charges" label="金额" />
        </el-table>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';

  @Component
  export default class ManufactureFlowsTable extends Vue {
    @Prop(Object) data
  }
</script>

<style lang="scss" scoped>
</style>
